<style scoped>
  .bigData-iframe{width: 100%;min-height:700px;border: none}
</style>

<template>
  <div>
    <iframe id="bigDataIframe" ref="bigDataIframe" class="bigData-iframe" :src="URL"></iframe>
  </div>
</template>

<script>
  export default {
    name: "mdPage",
    data(){
      return{
        URL:'about:blank',
      }
    },
    methods:{
      setIframeHeight:function (iframe) {
        if (iframe) {
          var iframeWin = iframe.contentWindow || iframe.contentDocument.parentWindow;
          if (iframeWin.document.body) {
            iframe.height = iframeWin.document.documentElement.scrollHeight || iframeWin.document.body.scrollHeight;
          }
        }
      },
      getURL:function(){
        var _this = this
        _this.send({
          headers:'To/ApplyConnect',
          success:function(res){
            _this.URL = 'https://open-data.fachans.com/datacenter?access_token='+res.access_token
            // _this.URL = 'https://fc.yunlianlaw.cn/datacenter?access_token='+res.access_token
          }

        })
      }
    },
    mounted:function(){
      this.getURL()
    },
    computed:{
      userId:function () {
        return window.sessionStorage.userId
      },
    }
  }
</script>